import * as React from 'react';
import { Images } from '../../../config';
import StyledImg from './styles';

const Logo = props => <StyledImg src={Images.UMATCH_WHITE_LOGO} alt='Umatch' title='umatch' {...props} />;

export default Logo;
